/**
 * Okvir oko uputstva, a ne samo uputstvo.
 *
 * Tekst uputstva — naslovi sekcija, koraci, napomene — dolazi sa servera, iz
 * `lang/*\/guide.php`, jer se isti tekst štampa i u PDF-u. Ovdje su samo
 * elementi ekrana koje server ne zna da postoje: dugme za preuzimanje, naslov
 * sadržaja, biranje uloge i rečenica koja kaže da gledate tuđe uputstvo.
 *
 * Ako vam se čini da nešto od sadržaja uputstva treba ovdje — ne treba. Dvije
 * kopije istog pasusa razilaze se prvi put kad neko izmijeni jednu.
 */

export const guide = {
  // Lista skokova na sekcije, na vrhu dokumenta. Dokument se čita odozgo
  // nadolje, ali kolega koji je poslan na jedan dio ne treba čitati ostalo.
  'guide.contents': 'Sadržaj',

  // Isti dokument na papiru. Tekst dugmeta stoji ovdje, a ne u `guide.php`,
  // jer ga vidi samo ekran — u PDF-u nema dugmeta za preuzimanje PDF-a.
  'guide.download': 'Preuzmi uputstvo (PDF)',

  'guide.empty': 'Za vašu ulogu još nije upisan nijedan korak. Javite administratoru.',

  // ---- Slike uz sekcije ---------------------------------------------
  // Opis slike i potpis ispod nje dolaze sa servera, jer se ista slika štampa
  // i u PDF-u. Ovdje je samo dugme kojim se slika otvara preko cijelog ekrana.
  //
  // U tekst dugmeta ulazi opis slike, a ne potpis: ko ne vidi sliku, čuje ovu
  // rečenicu umjesto nje, pa mu je korisnije šta je na slici nego zašto stoji
  // tu. Telefon uz mašinu prikazuje sliku široku nekoliko centimetara i sitna
  // slova na njoj se ne mogu pročitati bez uvećanja.
  'guide.figure.enlarge': 'Uvećaj sliku: {alt}',

  // ---- Pregled tuđeg uputstva (samo administrator) -------------------
  // Administrator koji prima novog radnika treba njegovo uputstvo, a ne svoje.
  // Rečenica ispod mora jasno reći da je to pregled: administrator koji pomisli
  // da je time nekome promijenio ulogu izgubiće popodne tražeći gdje da to
  // vrati.
  'guide.preview.label': 'Prikaži uputstvo za ulogu',
  'guide.preview.note':
    'Ovo je uputstvo koje vidi kolega sa ulogom {role}. Vaša uloga se time ne mijenja — ovo je samo pregled.',
} as const

export type GuideSlice = Record<keyof typeof guide, string>
